export default __webpack_public_path__ + "static/media/Thyroid.da2d8237.svg";